import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/horizontal-color-cropped.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/bridge/components/bridge.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/content-wrapper/content-wrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/section-layout/section-layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/bridge/components/transfer/index.tsx");
